import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {DatatableColumn} from '../model/column/datatable-column';
import {ColumnTypeEnumeration} from '../model/column/column-type.enumeration';

@Component({
  selector: 'nc-filter-dispatcher',
  templateUrl: './nc-filter-dispatcher.component.html',
  styleUrls: ['./nc-filter-dispatcher.component.scss']
})
export class NcFilterDispatcherComponent {
  @Input() column: DatatableColumn;
  @Input() formGroup: FormGroup;
  readonly type = ColumnTypeEnumeration;

  constructor() { }
}
